import {
  ArcElement,
  Chart as ChartJS,
  ChartData,
  Legend,
  Tooltip,
} from "chart.js";
import { observer } from "mobx-react";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import styled from "styled-components";

import Style from "@client/utils/Style";

ChartJS.register(ArcElement, Tooltip, Legend);

const Wrapper = styled.div`
  background: ${Style.palette.grayscale[0]};
  border-radius: ${Style.borderRadius};
`;
const Title = styled.div`
  font-size: 24px;
  font-weight: ${Style.fontWeights.light};
  margin-bottom: 12px;
  text-align: center;
`;
const ChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  title: string;
  data: ChartData<"doughnut", number[], string>;
  emptyComponent: React.ReactNode;
};

@observer
class DashboardPieChart extends React.Component<Props> {
  render() {
    const total = this.props.data.datasets[0].data.reduce((a, b) => a + b, 0);

    return (
      <Wrapper>
        <Title>{this.props.title}</Title>
        <ChartWrapper>
          {this.props.data.datasets[0].data.length > 0 ? (
            <Doughnut
              options={{
                plugins: {
                  legend: {
                    position: "bottom",
                  },
                  tooltip: {
                    callbacks: {
                      label(tooltipItem) {
                        const percentage = (
                          ((tooltipItem.raw as number) / total) *
                          100
                        ).toFixed(1);
                        return `${tooltipItem.label}: ${percentage}%`;
                      },
                    },
                  },
                },
              }}
              style={{ maxHeight: "400px" }}
              data={this.props.data}
            />
          ) : (
            this.props.emptyComponent
          )}
        </ChartWrapper>
      </Wrapper>
    );
  }
}

export default DashboardPieChart;
